const FORMAT = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i

module.exports = () => value => value && FORMAT.test(value)
